<template>
  <div class="school-container">
    <headers />

    <!-- Sub Navigation Bar -->
    <div class="school-sub-nav">
      <div class="school-sub-nav-content">
        <div class="sub-nav-tabs">
          <div
            class="sub-nav-tab"
            :class="{ active: activeSubTab === 0 }"
            @click="selectSubTab(0)"
          >
            首页
          </div>
          <div
            class="sub-nav-tab"
            :class="{ active: activeSubTab === 1 }"
            @click="selectSubTab(1)"
          >
            课程学习
          </div>
          <div
            class="sub-nav-tab"
            :class="{ active: activeSubTab === 2 }"
            @click="selectSubTab(2)"
          >
            学习课表
          </div>
          <div
            class="sub-nav-tab"
            :class="{ active: activeSubTab === 3 }"
            @click="selectSubTab(3)"
          >
            我的学习
          </div>
        </div>
        <div class="sub-nav-search">
          <input
            type="text"
            placeholder="搜索课程、课程包..."
            v-model="searchInputVal"
            @keyup.enter="handleSearch"
          />
          <div class="search-btn" @click="handleSearch">搜索</div>
        </div>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="school-main-body">
      <!-- Active Tab: 首页 (Dashboard 组件 或 搜索结果列表页) -->
      <template v-if="activeSubTab === 0">
        <SearchListView
          v-if="searchValue"
          :search-keyword="searchValue"
          :back-ground="backGround"
          :color-enum="colorEnum"
          @to-package-details="toPackageDetails"
          @to-details="toDetails"
          @clear-search="clearSearch"
        />
        <Dashboard
          v-else
          :banners="banners"
          :user="user"
          :company="company"
          :featured-packages="featuredPackages"
          :category-tree="categoryTree"
          @go-to-news="goToNews"
          @to-my-study="toMyStudy"
          @trigger-login="triggerLogin"
          @change-tab="selectSubTab"
          @to-package-details="toPackageDetails"
          @to-courses-with-classify="
            (val) => toCoursesWithClassify(val.id, val.name)
          "
          @to-details="toDetails"
        />
      </template>

      <!-- Active Tab: 课程学习 (CoursesView 组件) -->
      <CoursesView
        v-else-if="activeSubTab === 1"
        :category-tree="courseCategoryTree"
        :head-tab-list="headTabList"
        :back-ground="backGround"
        :color-enum="colorEnum"
        :initial-classify-id="classifyId"
        :global-search-val="searchValue"
      />
      <!-- 学习课表 -->
      <StudySchedule
        v-else-if="activeSubTab === 2"
        @to-package-details="toPackageDetails"
      />

      <!-- Active Tab: 我的学习 -->
      <MyStudy
        v-else-if="activeSubTab === 3"
        :user="user"
        :company="company"
        @to-package-details="toPackageDetails"
        @to-details="toDetails"
      />
    </div>
    <div style="margin-top: 40px"></div>
    <footers />
  </div>
</template>

<script>
import headers from "@/components/header.vue";
import footers from "@/components/footer.vue";
import Dashboard from "./components/Dashboard.vue";
import CoursesView from "./components/CoursesView.vue";
import StudySchedule from "./components/StudySchedule.vue";
import SearchListView from "./components/SearchListView.vue";
import MyStudy from "./components/MyStudy.vue";

import {
  videoEquityList,
  banner,
  coursePackageFeaturedList,
  courseClassifyHomeList,
  courseClassifyListAll,
  userDetail,
  userCompany,
} from "@/api/lx";

export default {
  name: "schoolIndex",
  components: {
    headers,
    footers,
    Dashboard,
    CoursesView,
    StudySchedule,
    SearchListView,
    MyStudy,
  },
  data() {
    return {
      backGround: {
        L1: "rgba(0, 216, 195, 0.1)",
        L2: "rgba(240, 193, 11, 0.1)",
        L3: "rgba(71, 177, 226, 0.1)",
        L4: "rgba(147, 93, 228, 0.1)",
      },
      colorEnum: {
        L1: "#00D8C3",
        L2: "#F0C10B",
        L3: "#47B1E2",
        L4: "#935DE4",
      },
      headTabList: [],
      searchValue: "",
      classifyId: "",
      activeSubTab: 0, // 0 = 首页, 1 = 课程学习, 2 = 学习课表
      banners: [],
      featuredPackages: [],
      categoryTree: [],
      courseCategoryTree: [],
      user: null,
      company: null,
      searchInputVal: "",
      hasLoadedOnCreated: false,
    };
  },

  // 每次回到当前页面的事件
  activated() {
    this.handleRouteParams();
    if (this.hasLoadedOnCreated) {
      this.hasLoadedOnCreated = false;
      return;
    }
    this.loadDataForTab(this.activeSubTab);
  },
  created() {
    this.handleRouteParams();
    this.loadDataForTab(this.activeSubTab);
    this.hasLoadedOnCreated = true;
    this.$root.$on("refreshUserInfo", this.getUserInfo);
  },
  beforeDestroy() {
    this.$root.$off("refreshUserInfo", this.getUserInfo);
  },
  methods: {
    /**
     * 解析路由携带的参数并切换 Tab
     * @returns {void}
     */
    handleRouteParams() {
      const queryId = this.$route.query.id;
      const tab = this.$route.query.tab;

      if (tab !== undefined && tab !== null) {
        this.activeSubTab = Number(tab);
      } else if (queryId) {
        this.classifyId = queryId;
        this.activeSubTab = 1;
      }

      // 如果进入的不是首页(0)，自动清空搜索条件
      if (this.activeSubTab !== 0) {
        this.searchValue = "";
        this.searchInputVal = "";
      }
    },
    /**
     * 获取学院主页轮播图数据
     * @returns {void}
     */
    getBanners() {
      banner({ bannerType: 2 }).then((res) => {
        if (res.code == 200) {
          this.banners = res.data || [];
        }
      });
    },
    /**
     * 获取推荐课程包列表数据
     * @returns {void}
     */
    getFeaturedPackages() {
      coursePackageFeaturedList().then((res) => {
        if (res.code == 200) {
          this.featuredPackages = res.data || [];
        }
      });
    },
    /**
     * 获取分类树数据
     * @returns {void}
     */
    getCategoryTree() {
      courseClassifyHomeList().then((res) => {
        if (res.code == 200) {
          this.categoryTree = res.data || [];
        }
      });
    },
    /**
     * 获取全部课程分类树数据（不含推荐课程等首页定制内容）
     * @returns {void}
     */
    getCourseCategoryTree() {
      courseClassifyListAll().then((res) => {
        if (res.code == 200) {
          this.courseCategoryTree = res.data || [];
        }
      });
    },
    /**
     * 获取用户信息
     * @returns {void}
     */
    getUserInfo() {
      const token = localStorage.getItem("token");
      if (token) {
        userDetail({}).then((res) => {
          if (res.code == 200) {
            this.user = res.data;
            localStorage.setItem("user", JSON.stringify(res.data));
          }
        });
      } else {
        this.user = null;
      }
    },
    /**
     * 获取用户绑定的企业/等级权益数据
     * @returns {void}
     */
    getUserCompany() {
      const token = localStorage.getItem("token");
      if (token) {
        userCompany({}).then((res) => {
          if (res.code == 200) {
            this.company = res.data;
          }
        });
      } else {
        this.company = null;
      }
    },
    /**
     * 获取权益等级列表（模式项）
     * @returns {void}
     */
    getVideoEquityList() {
      videoEquityList({}).then((res) => {
        this.headTabList = res.data || [];
      });
    },
    /**
     * 切换全局 Sub Tab
     * @param {number} val - 目的 Tab 索引
     * @returns {void}
     */
    selectSubTab(val) {
      if (val === 3) {
        this.toMyStudy();
        return;
      }
      if (this.activeSubTab === val) return;
      this.activeSubTab = val;
      if (val !== 0) {
        this.searchValue = "";
        this.searchInputVal = "";
      }
      this.loadDataForTab(val);
    },
    /**
     * 依据当前激活的 Tab 懒加载所需数据
     * @param {number} tab - 切换目的 Tab 索引
     * @returns {void}
     */
    loadDataForTab(tab) {
      if (tab === 0) {
        this.getBanners();
        this.getFeaturedPackages();
        this.getCategoryTree();
        this.getUserInfo();
        this.getUserCompany();
      } else if (tab === 1) {
        if (this.headTabList.length === 0) {
          this.getVideoEquityList();
        }
        if (this.courseCategoryTree.length === 0) {
          this.getCourseCategoryTree();
        }
      } else if (tab === 2) {
        this.getFeaturedPackages();
      } else if (tab === 3) {
        this.getUserInfo();
        this.getUserCompany();
      }
    },
    /**
     * 全局顶部搜索回车/点击触发
     * @returns {void}
     */
    handleSearch() {
      this.searchValue = this.searchInputVal;
      this.activeSubTab = 0;
    },
    /**
     * 清空搜索内容并恢复普通首页
     * @returns {void}
     */
    clearSearch() {
      this.searchValue = "";
      this.searchInputVal = "";
    },
    /**
     * 看板卡片点击分类切换至学习列表并联动高亮
     * @param {string|number} id - 分类ID
     * @param {string} name - 分类名称
     * @returns {void}
     */
    toCoursesWithClassify(id, name) {
      this.classifyId = id;
      this.activeSubTab = 1;
      this.loadDataForTab(1);
    },
    /**
     * 跳转至课程详情
     * @param {Object} item - 课程元数据
     * @returns {void}
     */
    toDetails(item) {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push({ path: "/login" });
        return;
      }
      if (!item.canView) {
        this.$message.warning("抱歉，当前课程暂无权限学习");
        return;
      }
      this.$router.push({
        path: "/school/details",
        query: {
          id: item.id,
          classifyName: "全部",
          classifyId: "",
          videoId: item.videoId || "",
        },
      });
    },
    /**
     * 跳转至课程包详情
     * @param {Object} item - 课程包元数据
     * @returns {void}
     */
    toPackageDetails(item) {
      const token = localStorage.getItem("token");
      if (!token) {
        this.$router.push({ path: "/login" });
        return;
      }
      this.$router.push({
        path: "/school/packageDetails",
        query: { id: item.id },
      });
    },
    /**
     * 跳转至“我的学习中心”
     * @returns {void}
     */
    toMyStudy() {
      this.activeSubTab = 3;
    },
    /**
     * 触发调起登录框
     * @returns {void}
     */
    triggerLogin() {
      this.$store.dispatch("showAuthModal");
    },
    /**
     * 跳转至文章资讯详情
     * @param {Object} item - 新闻元数据
     * @returns {void}
     */
    goToNews(item) {
      if (item.jumpType == 1) {
        this.$router.push({
          path: "/news/details",
          query: { id: item.jumpId, actTab: 1 },
        });
      } else if (item.jumpType == 2) {
        this.$router.push({
          path: "/news/details",
          query: { id: item.jumpId, actTab: 2 },
        });
      } else if (item.jumpType == 3) {
        this.$router.push({
          path: "/school/details",
          query: { id: item.jumpId },
        });
      } else if (item.jumpType == 4) {
        this.$router.push({
          path: "/school/packageDetails",
          query: { id: item.jumpId },
        });
      }
    },
  },
  watch: {
    $route: {
      handler() {
        this.handleRouteParams();
        this.loadDataForTab(this.activeSubTab);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.school-container {
  width: 100%;
  box-sizing: border-box;
  background-color: #f9fafc;
}

/* Sub-navigation bar styling */
.school-sub-nav {
  width: 100%;
  height: 74px;
  background: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid rgba(186, 202, 198, 0.15);
}
.school-sub-nav-content {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.school-main-body {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}
.sub-nav-tabs {
  height: 74px;
  display: flex;
  align-items: center;
  gap: 40px;
}
.sub-nav-tab {
  height: 74px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-family: PingFangSC, PingFang SC;
  font-size: 16px;
  font-weight: 500;
  color: #3b4a47;
  cursor: pointer;
  border-bottom: 4px solid transparent;
  transition: all 0.3s;
}
.sub-nav-tab:hover,
.sub-nav-tab.active {
  color: #00d8c3;
  font-weight: 700;
  border-bottom-color: #00d8c3;
}

.sub-nav-search {
  width: 420px;
  height: 46px;
  background: #f6f3f2;
  border-radius: 8px;

  display: flex;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  input {
    flex: 1;
    border: none;
    background: transparent;
    padding: 0 16px;
    height: 100%;
    outline: none;
    font-size: 14px;
    color: #3b4a47;
    &::placeholder {
      color: #6b7280;
    }
  }
  .search-btn {
    height: 100%;
    padding: 0 32px;
    background: #00d8c3;
    color: white;
    font-weight: 700;
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s;
    user-select: none;
    &:hover {
      background: #00c4b0;
    }
  }
}
</style>
